import React, { useState } from 'react';
import { toast } from 'react-toastify';
import produce from 'immer';
import { v4 as uuidv4 } from 'uuid';

import {
  Modal,
  Button,
  TextArea,
  InputFile,
  WrapperFlex,
} from '@unimed-fesp/components';

import { ModalContent, ModalContentWrapper } from '../../molecules/Modal';
import { WarningToast } from '../../molecules/Toast';

import { Badges } from '../../atoms/Badges';

import { getBase64 } from '../../../utils/array';

function ModalMotivoRecusa({
  isOpen,
  onClick,
  onClickEnviar,
  idArquivo,
  hasObrigatoriedadeFile,
}) {
  const motivoRecusaParams = {
    motivoRecusa: null,
  };

  const [files, setFiles] = useState([]);
  const [motivoRecusa, setMotivoRecusa] = useState(motivoRecusaParams);

  function handlerInputError(errors) {
    if (errors.fileErrors.length > 0) {
      if (errors.fileErrors[0].error.hasMaxSize) {
        toast.error(
          <WarningToast>
            O arquivo ultrapassou o limite máximo de 5mb
          </WarningToast>
        );
      } else if (errors.fileErrors[0].error.hasNoContent) {
        toast.error(<WarningToast>O arquivo não possui conteúdo</WarningToast>);
      } else if (errors.fileErrors[0].error.hasValidExtension) {
        toast.error(
          <WarningToast>
            O arquivo enviado não possui uma extensão válida
          </WarningToast>
        );
      } else if (errors.hasMaxQuantity) {
        toast.error(
          <WarningToast>Deve-se enviar apenas 1 arquivo</WarningToast>
        );
      }
    }
  }

  function removeFile(idFile) {
    const newFiles = produce(files, (draft) => {
      draft = draft.filter((file) => file.idFile !== idFile);

      return draft;
    });
    setFiles(newFiles);
  }

  function handleInputChange(e, status) {
    const newMotivoRecusaParams = produce(motivoRecusaParams, (draft) => {
      if (draft[status] !== e.target.value) draft[status] = e.target.value;

      return draft;
    });
    setMotivoRecusa(newMotivoRecusaParams);
  }

  async function handleFile(file) {
    const base64 = await getBase64(file);
    return {
      file,
      name: file.name,
      readableSize: file.size,
      preview: URL.createObjectURL(file),
      progress: 0,
      uploaded: false,
      error: false,
      url: null,
      base64,
      idFile: uuidv4(),
    };
  }

  function handleValidations(filesInput) {
    const maxSizeFiles = 5242880;
    const maxQuantityFiles = 1;

    const validExtension = [
      'txt',
      'doc',
      'docx',
      'xls',
      'xlsx',
      'jpg',
      'jpeg',
      'png',
      'tiff',
      'pdf',
    ];
    const errors = {
      hasMaxSize: false,
      hasMaxQuantity: false,
      hasValidExtension: false,
    };

    const fileErrors = [];
    const filteredFiles = filesInput.filter((item) => {
      errors.hasMaxSize = false;
      errors.hasValidExtension = false;
      if (item.readableSize > maxSizeFiles) errors.hasMaxSize = true;

      if (!validExtension.includes(item.name.split('.').pop().toLowerCase()))
        errors.hasValidExtension = true;

      if (filesInput.length > maxQuantityFiles) errors.hasMaxQuantity = true;
      if (
        !(item.readableSize > maxSizeFiles) &&
        validExtension.includes(item.name.split('.').pop().toLowerCase()) &&
        filesInput.length <= maxQuantityFiles
      ) {
        return item;
      }
      const { hasMaxQuantity, ...rest } = errors;
      fileErrors.push({ error: rest, item });
    });

    handlerInputError({ fileErrors, hasMaxQuantity: errors.hasMaxQuantity });

    return filteredFiles;
  }

  return (
    <Modal
      height={611}
      top={45}
      width={916}
      isOpen={isOpen}
      onClick={onClick}
      header={<>motivo de recusa de documentos</>}
      footer={
        <ModalFooter
          onClick={onClick}
          isDisabledBtnEnviar={
            !motivoRecusa.motivoRecusa ||
            (hasObrigatoriedadeFile && files.length <= 0)
          }
          handleRecusarArquivo={() => {
            const params = {
              idArquivo,
              statusConferencia: 'Recusado',
              mensagemConferencia: motivoRecusa.motivoRecusa,
              arquivoConferencia: files[0]?.base64,
              extensaoArquivoConferencia: files[0]?.name.split('.')[1],
            };

            onClickEnviar(params);
            setFiles([]);
            setMotivoRecusa(motivoRecusaParams);
          }}
        />
      }
    >
      <ModalContentWrapper height="440">
        <ModalContent
          width="100%"
          height="100%"
          overflow="hidden"
          maxHeight="none"
        >
          <WrapperFlex justifySpaceBetween fullWidth column marginSides={20}>
            <TextArea
              labelText="Motivo de recusa"
              handleChange={(e) => {
                handleInputChange(e, 'motivoRecusa');
              }}
              name="motivoRecusa"
              width={860}
              height={170}
              value={motivoRecusa.motivoRecusa}
            />
            <InputFile
              setFiles={setFiles}
              placeHolder="Insira um arquivo para anexa-lo"
              marginLeft={5}
              applyValidation
              labelText="Anexos"
              shapeFile={handleFile}
              customValidations={handleValidations}
            />
            <WrapperFlex justifyStart marginTop={10} flexWrap>
              {files.map((file) => (
                <Badges margin="2" remove={() => removeFile(file.idFile)}>
                  {file.name}
                </Badges>
              ))}
            </WrapperFlex>
          </WrapperFlex>
        </ModalContent>
      </ModalContentWrapper>
    </Modal>
  );
}

const ModalFooter = ({
  onClick,
  isDisabledBtnEnviar,
  handleRecusarArquivo,
}) => {
  return (
    <WrapperFlex justifySpaceBetween fullWidth>
      <Button
        tipo="tertiary"
        justifySpaceAround
        alignCenter
        width={100}
        font="16px unimed_slabregular"
        onClick={onClick}
      >
        cancelar
      </Button>
      <WrapperFlex justifyEnd>
        <Button
          tipo="primary"
          justifySpaceAround
          alignCenter
          disabled={isDisabledBtnEnviar}
          width={100}
          font="16px unimed_slabregular"
          onClick={() => handleRecusarArquivo()}
        >
          enviar
        </Button>
      </WrapperFlex>
    </WrapperFlex>
  );
};

export default ModalMotivoRecusa;
